/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @group Constants
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 * 
 * @example
 * ```typescript
 * import { DATABASE_RESOURCES } from '@shared/utils';
 * 
 * // Use database resource constants
 * const resource = DATABASE_RESOURCES.USERS;
 * ```
 */
export const DATABASE_RESOURCES = {
  DB_CONSULTATION: 'db_consultation',
  DB_DATADELETIONREQUEST: 'db_datadeletionrequest',
  DB_EHRINTEGRATION: 'db_ehrintegration',
  DB_HEALTHRECORDUPLOAD: 'db_healthrecordupload',
  DB_PATIENTPAYMENTMETHOD: 'db_patientpaymentmethod',
  DB_PATIENTPROFILE: 'db_patientprofile',
  DB_ROLE: 'db_role',
  DB_ROLERESOURCEPERMISSION: 'db_roleresourcepermission',
  DB_TENANT: 'db_tenant',
  DB_TENANTUSER: 'db_tenantuser',
  DB_USER: 'db_user',
  DB_USERROLE: 'db_userrole',
} as const;